import styled from 'styled-components';
import { style } from 'styled-system';
import { useThemeDefaults } from '../utils';
import Box from '../Box';
var gridGap = style({
  prop: 'gridGap',
  key: 'space'
}); // new version of gridGap

var gap = style({
  prop: 'gap',
  key: 'space'
});
var gridColumnGap = style({
  prop: 'gridColumnGap',
  key: 'space'
});
var gridRowGap = style({
  prop: 'gridRowGap',
  key: 'space'
});
var gridAutoFlow = style({
  prop: 'gridAutoFlow'
});
var gridAutoColumns = style({
  prop: 'gridAutoColumns'
});
var gridAutoRows = style({
  prop: 'gridAutoRows'
});
var gridTemplateColumns = style({
  prop: 'gridTemplateColumns'
});
var gridTemplateRows = style({
  prop: 'gridTemplateRows'
});
var gridTemplateAreas = style({
  prop: 'gridTemplateAreas'
});
/**
 * Grid item properties are already available on Box, so that Box can be used
 * as children of Grid
 */

var Grid = useThemeDefaults(function () {
  return {
    display: 'grid'
  };
}, styled(Box).withConfig({
  displayName: "Grid",
  componentId: "sc-6k42qf-0"
})(gap, gridGap, gridColumnGap, gridRowGap, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas));
export default Grid;